export default "__VITE_PUBLIC_ASSET__cfaffa73__"